// extracted by mini-css-extract-plugin
module.exports = {"customer":"JUEvZVoUgjDAuNhRGlw-h"};